import {Injectable} from '@angular/core';
import {DEFAULT_DB_NAME, DEFAULT_DB_VERSION, INDEX_DB_STORES} from '../../shared/utils/db-migration';

// declare var createDB: any;
// declare var add: any;
// declare var get: any;
// declare var deleteItem: any;
// declare var update: any;
// declare var clearData: any;
// declare var deleteDb: any;

@Injectable({
	providedIn: 'root'
})
export class IndexDBService {

	constructor() {
    console.log(' IndexDBService  ---> ');
	}

	createIndexDB(): Promise<any> {
    return this.mockResponse();
		// return createDB(DEFAULT_DB_NAME, DEFAULT_DB_VERSION, INDEX_DB_STORES);
	}

  mockResponse(){
    return new Promise( (resolve, reject) => {resolve(true)});
  }

	get(tableName: string, searchParam: any): Promise<any> {
		// return get(tableName, searchParam);
    return this.mockResponse();
	}

	add(data: any [] = [], tableName: string): Promise<any> {
		// return add(data, tableName);
    return this.mockResponse();
	}

	deleteDb(dbName): Promise<any> {
		// return deleteDb(dbName);
    return this.mockResponse();
	}

	update(data: any, tableName: string): Promise<any> {
		// return update(data, tableName);
    return this.mockResponse();
	}

	delete(tableName: string, key): Promise<any> {
		// return deleteItem(tableName, key);
    return this.mockResponse();
	}

	clearData(tableName): Promise<any> {
		// return clearData(tableName);
    return this.mockResponse();
	}
}

